var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseCheckpointModel } from '../BaseCheckpointModel';
import { observable, action } from 'mobx';
export class SanctionsList extends BaseCheckpointModel {
    constructor(data) {
        super(data);
        Object.assign(this, data);
    }
    toJson() {
        return {
            description: this.description,
            type: this.type,
            comment: this.comment,
            discrepancy: this.discrepancy,
            researcherId: this.researcherId,
            verificationDate: this.verificationDate
        };
    }
}
__decorate([
    observable
], SanctionsList.prototype, "description", void 0);
__decorate([
    action
], SanctionsList.prototype, "toJson", null);
export default SanctionsList;
